import React, { useEffect, useState } from 'react'
import { CustomDropdownPriceList } from './CustomDropdownPriceList'
import { getListPricesAction } from 'redux/actions/clientsActions'
import { typePriceLists } from 'Utils/constants'

export const PriceList = ({ priceListSelected, setPriceListSelected }) => {
  const [listPrices, setListPrices] = useState([])

  const fetchListPrices = async typeId => {
    const payload = {
      CompanyId: null,
      GlobalExecution: true,
      PriceListTypeId: typeId,
      PageNumber: 1,
      PageSize: 999,
    }
    return await getListPricesAction(payload)()
  }

  useEffect(() => {
    const fetchAllLists = async () => {
      try {
        const [catalogList, discountList] = await Promise.all([
          fetchListPrices(typePriceLists.catalog),
          fetchListPrices(typePriceLists.discountmatrix),
        ])
        const combined = [...catalogList, ...discountList]
        setListPrices(combined)
      } catch (error) {
        console.error('Error fetching price lists:', error)
      }
    }

    fetchAllLists()
  }, [])

  return (
    <CustomDropdownPriceList
      label="Listas de precios"
      value={priceListSelected}
      options={listPrices}
      onSelect={setPriceListSelected}
      getOptionLabel={item => `${item.Code} - ${item.Description}`}
      getOptionValue={item => item.PriceListId}
      error={
        priceListSelected?.length > 1
          ? 'Solo se permite 1 sola lista de precios'
          : ''
      }
    />
  )
}
